export type WbsStatusKind = 'ON_TRACK' | 'IMPENDING' | 'RISK' | 'DELAY' | 'PLANNED';

export const STATUS = {
    ON_TRACK: 'ON_TRACK',
    RISK: 'RISK',
    DELAY: 'DELAY',
    PLANNED: 'PLANNED',
    IMPENDING: 'IMPENDING',
} as const;

export const STATUS_LABEL_KO: Record<WbsStatusKind, string> = {
    ON_TRACK: '정시',
    RISK: '주의',
    DELAY: '지연',
    PLANNED: '예정',
    IMPENDING: '임박',
};

export const THRESHOLDS = {
    IMPENDING_DAYS: 7,
    ONTRACK_ABS_GAP: 2,     // abs(PV - EV) < 1이면 정시
    RISK_GAP: 10,            // PV - EV < 5 이면 주의
    DELAY_GAP: 10,           // PV - EV >= 5 이면 지연 (경계 고정)
    // GAP_IMPENDING: 3,
    // GAP_RISK: 10,
} as const;
